/*
  Centro de ayuda Deporbox.
  - [data-dbx-help-search]  buscador: filtra las preguntas de [data-dbx-help-faq] mientras escribes
  - [data-dbx-help-chip]    sugerencias: rellenan el buscador (data-query)
  - [data-dbx-help-count]   contadores: nº de preguntas de una categoría (data-category, data-template con [n])
  - [data-dbx-help-feedback] botones «¿Te ha ayudado?»: guardan la respuesta en el navegador
  Admite ?q=texto en la URL.
*/
(function () {
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fill(template, n) {
    return String(template || '')
      .replace(/\[n\]/g, n)
      .replace(/\b1 preguntas\b/g, '1 pregunta');
  }

  function faqRoots() {
    return $all('[data-dbx-help-faq]');
  }

  function renderCounts() {
    $all('[data-dbx-help-count]').forEach(function (el) {
      var key = el.getAttribute('data-category');
      var n = 0;
      faqRoots().forEach(function (root) {
        n += $all('[data-dbx-help-category]:not([data-dbx-hidden]) [data-dbx-help-question][data-category="' + key + '"]', root).length;
      });
      el.textContent = fill(el.getAttribute('data-template'), n);
    });
  }

  function search(term) {
    var q = norm(term);
    var words = q ? q.split(' ') : [];
    var total = 0;
    faqRoots().forEach(function (root) {
      $all('[data-dbx-help-category]', root).forEach(function (cat) {
        // Categorías ocultas desde el editor: siempre ocultas
        if (cat.hasAttribute('data-dbx-hidden')) {
          cat.hidden = true;
          return;
        }
        var visible = 0;
        $all('[data-dbx-help-question]', cat).forEach(function (item) {
          var text = norm(item.textContent);
          var match = words.every(function (w) {
            return text.indexOf(w) !== -1;
          });
          item.hidden = !match;
          if (match) visible++;
          // Con búsqueda activa, se abre la primera coincidencia de cada categoría
          if (q && match && visible === 1) item.open = true;
        });
        cat.hidden = visible === 0;
        total += visible;
      });
      var empty = root.querySelector('[data-dbx-help-empty]');
      if (empty) empty.hidden = total !== 0;
      var status = root.querySelector('[data-dbx-help-status]');
      if (status) {
        status.textContent = q ? fill(status.getAttribute(total === 1 ? 'data-one' : 'data-many'), total) : '';
      }
    });
    $all('[data-dbx-help-search]').forEach(function (input) {
      var clear = input.parentNode.querySelector('[data-dbx-help-clear]');
      if (clear) clear.hidden = !input.value;
    });
  }

  function scrollToFaq() {
    var root = faqRoots()[0];
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    renderCounts();

    $all('[data-dbx-help-search]').forEach(function (input) {
      if (input.dataset.dbxReady) return;
      input.dataset.dbxReady = 'true';
      input.addEventListener('input', function () {
        search(input.value);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          search(input.value);
          scrollToFaq();
        }
      });
      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          search(input.value);
          scrollToFaq();
        });
      }
    });

    try {
      var q = new URLSearchParams(window.location.search).get('q');
      if (q) {
        $all('[data-dbx-help-search]').forEach(function (input) {
          input.value = q;
        });
        search(q);
      }
    } catch (e) {}

    // Respuestas guardadas de «¿Te ha ayudado?»
    $all('[data-dbx-help-feedback]').forEach(function (box) {
      var key = 'dbx-help-' + box.getAttribute('data-dbx-help-feedback');
      var saved = null;
      try {
        saved = window.localStorage.getItem(key);
      } catch (e) {}
      if (saved) box.classList.add('is-answered');
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-dbx-help-chip]');
    if (chip) {
      e.preventDefault();
      var query = chip.getAttribute('data-query') || chip.textContent;
      $all('[data-dbx-help-search]').forEach(function (input) {
        input.value = query;
      });
      search(query);
      scrollToFaq();
      return;
    }

    var clear = e.target.closest('[data-dbx-help-clear]');
    if (clear) {
      $all('[data-dbx-help-search]').forEach(function (input) {
        input.value = '';
      });
      search('');
      return;
    }

    var vote = e.target.closest('[data-dbx-help-vote]');
    if (vote) {
      var box = vote.closest('[data-dbx-help-feedback]');
      box.classList.add('is-answered');
      try {
        window.localStorage.setItem('dbx-help-' + box.getAttribute('data-dbx-help-feedback'), vote.getAttribute('data-dbx-help-vote'));
      } catch (err) {}
      return;
    }

    // Tarjetas y enlaces a una categoría: limpiar la búsqueda para que se vea completa
    var catLink = e.target.closest('[data-dbx-help-goto]');
    if (catLink) {
      $all('[data-dbx-help-search]').forEach(function (input) {
        input.value = '';
      });
      search('');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['shopify:section:load', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(init, 50);
    });
  });
})();
